import React from 'react';
import InputField from '../../../../../Components/Form/components/InputField';

const CSSZAddressContainer: React.FC = () => {
	return (
		<>
			<div className='row'>
				<div className='col-6'>
					<InputField
						name='street'
						label='component.CSSZAddressContainer.street'
						isWrapped
					/>
				</div>
				<div className='col-3'>
					<InputField
						name='descriptiveNumber'
						label='component.CSSZAddressContainer.descriptiveNumber'
						isRequired
						isWrapped
					/>
				</div>
				<div className='col-3'>
					<InputField
						name='guideNumber'
						label='component.CSSZAddressContainer.guideNumber'
						isWrapped
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-6'>
					<InputField
						name='floor'
						label='component.CSSZAddressContainer.floor'
						isWrapped
					/>
				</div>
				<div className='col-6'>
					<InputField
						name='postCode'
						label='component.CSSZAddressContainer.postCode'
						isRequired
						isWrapped
					/>
				</div>
			</div>
			<div className='row'>
				<div className='col-6'>
					<InputField
						name='city'
						label='component.CSSZAddressContainer.city'
						isRequired
						isWrapped
					/>
				</div>
				<div className='col-6'>
					<InputField
						name='partOfCity'
						label='component.CSSZAddressContainer.partOfCity'
						isWrapped
					/>
				</div>
			</div>
			<InputField
				name='note'
				label='component.CSSZAddressContainer.note'
				isWrapped
			/>
		</>
	);
};

export default CSSZAddressContainer;
